module.exports = __webpack_public_path__ + "media/mypage/images/menu/spm6-e2dd52f953a93a134eeaa5101ec25819.png";